<script setup>
import {globalEmitter} from "@straylightagency/events";
import {fadeHide, fadeShow, slideHide, slideToggle} from "@straylightagency/animate";
import {onMounted, onUnmounted, ref} from "vue";

const {id, data} = defineProps(['id', 'data']);

const state = ref( false );
const itemEl = ref();

async function toggle() {
    if ( state.value === false ) {
        globalEmitter.emit('faq:hide', [{id}]);
        state.value = true;
    } else {
        state.value = false;
    }

    await slideToggle( itemEl.value, 200, "easeLinear", "block");

    // itemEl.value.querySelectorAll('.corner').forEach( el => {
    //     state.value ?
    //         fadeShow( el, 200, "easeLinear", "block") :
    //         fadeHide( el, 200, "easeLinear");
    // } );
}

const callback = async ({i}) => {
    if ( i !== id ) {
        state.value = false;
        await slideHide( itemEl.value, 200, "easeLinear");
        // itemEl.value.querySelectorAll('.corner').forEach( el => {
        //     fadeHide( el, 200, "easeLinear");
        // } );
    }
};

onMounted( () => {
    globalEmitter.on('faq:hide', callback );
} );

onUnmounted( () => {
    globalEmitter.off('faq:hide', callback );
} );
</script>

<template>
    <li>
        <div class="text-white font-bold text-lg">
            <button class="faq-button | relative block py-2 cursor-pointer w-full text-left"
                    :class="{'faq-opened': state}" v-html="data['question']" @click.prevent="toggle"></button>
        </div>
        <div class="hidden" ref="itemEl">
            <div class="relative text-white leading-loose p-2 mt-4">
                <p v-html="data['answer']"></p>
                <span class="corner | corner-top-left corner-top-right"></span>
                <span class="corner | corner-bottom-left corner-bottom-right"></span>
            </div>
        </div>
    </li>
</template>